module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/70cd31411b171b5922b28997c6545ca0.svg";